import { render, staticRenderFns } from "./ComponentsAppMain.vue?vue&type=template&id=e90c4c9e&scoped=true"
import script from "./ComponentsAppMain.vue?vue&type=script&lang=ts"
export * from "./ComponentsAppMain.vue?vue&type=script&lang=ts"
import style0 from "./ComponentsAppMain.vue?vue&type=style&index=0&id=e90c4c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90c4c9e",
  null
  
)

export default component.exports